import React, { useState } from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { listApprovalAlert } from './listApprovalSlice';
import { selector as listAlertsApi } from './listApprovalSlice';
import {useSpinner} from "../../../customHooks";
import { Status } from '../../../common/constants';
import { actions as spinnerActions } from '../../../components/ui/spinner/spinnerSlice';
import { IInitialSliceState } from '../../../common/types/commonTypes';

interface IApproveAlertResponseState {
    approveAlertApi: IInitialSliceState;
    denyAlertApi: IInitialSliceState
  }
  
export const useApprovalAlerts = () => {
     const [denyPop, setDenyPop] = useState<Boolean>(false);
   const [approvePop, setApprovePop] = useState<Boolean>(false);
   const [ selectedAlert,setSelectedAlert] = useState(null);
    const dispatch: any = useDispatch();
    const listAlertResponse = useSelector(listAlertsApi);
    const data = listAlertResponse?.data;
    const approveAlertResponse = useSelector(
        (state: IApproveAlertResponseState) => state.approveAlertApi
      );
      const denyAlertResponse = useSelector(
        (state: IApproveAlertResponseState) => state.denyAlertApi
      );
      
    useSpinner(approveAlertResponse.status);
    useSpinner(denyAlertResponse.status);
      
    React.useEffect(() => {
        dispatch(spinnerActions.setApiStatus(listAlertResponse.status));
    }, [listAlertResponse.status])

    React.useEffect(() => {
        dispatch(listApprovalAlert());
    }, [])

    const handleDenyClick = (item)=>{
        setDenyPop(true);
        setSelectedAlert(item);
    }

    const handleApproveClick = (item)=>{
        setApprovePop(true);
        setSelectedAlert(item);
    }
    
    return {
        data,
        denyPop,
        setDenyPop,
        approvePop,
        setApprovePop,
        selectedAlert,
        setSelectedAlert,
        handleDenyClick,
        handleApproveClick
    };
}
